import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";

import styled from "styled-components";

import Calendar from "react-calendar/dist/entry.nostyle";

import { Block, Overlay, Portal } from "reakit";
import { Box, Flex, Heading, Text } from "rebass";
import IosArrowBack from "react-ionicons/lib/IosArrowBack";
import IosArrowForward from "react-ionicons/lib/IosArrowForward";
import activeCircle from "../../resources/img/icons/wave-calendar-circle.png";

import MdArrowDropright from "react-ionicons/lib/MdArrowDropright";
import MdArrowDropleft from "react-ionicons/lib/MdArrowDropleft";

import HealthAdminDetails from "./HealthAdminDetails";

const textProps = {
  fontSize: "16px",
  fontWeight: 600,
  ml: "7px",
  textAlign: "left",
};

const FilterOverlay = styled(Overlay)`
  width: 100%;
  margin: 0;
  padding: 0;
  height: 100%;
  overflow: scroll;
`;

const CalenderWrapper = styled(Box)`
  //width: 100vw;

  & * {
  color: white;
  //border: none;
  padding: 2px;
  }
  .react-calendar {
    &, & *, & *:before, & *:after {
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
   }
   button {
    margin: 0;
    border: 0;
    outline: none;

    &:enabled {
      &:hover {
        cursor: pointer;
        }
      }
    }
    &__navigation {
	    height: 44px;
	    margin-bottom: 1em;
	    
	    //&__next-button {
	    //	margin-left: -50px;
	    //}
	    //
	    //&__prev-button {
	    //	margin-left: -50px;
	    //}
	    &__next2-button {
						visibility: hidden;
				}
				
			&__prev2-button {
					visibility: hidden;
			}
	
	    button {
	      min-width: 44px;
	      background: none;
	      font-size: 17px;
	      font-weight: 500;
	
	      &:enabled {
	        &:hover, &:focus {
	          //background-color: rgb(230, 230, 230);
	        }
	      }
	
	      &[disabled] {
	        background-color: rgb(240, 240, 240);
	      }
	    }
  }
  
    &__month-view {
    &__weekdays {
      text-align: center;
      text-transform: uppercase;
      font-weight: bold;
      font-size: .75em;
      abbr {
      color: #969a9b;
      text-decoration: none;
      }
			
      &__weekday {
        padding: .5em;
      }
    }

    &__weekNumbers {
      font-weight: bold;

      .react-calendar__tile {
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: .75em;
        padding: calc(.75em / .75) calc(.5em / .75);
      }
    }

    &__days {
      &__day {
        &--weekend {
          color: red;
        }

        &--neighboringMonth {
          color: rgb(150, 150, 150);
        }
      }
    }
  }

  &__year-view,
  &__decade-view,
  &__century-view {
    .react-calendar__tile {
      padding: 2em .5em;
    }
  }
  
    &__tile {
    max-width: 100%;
    text-align: center;
    padding: .75em .5em;
    background: none;
    &:disabled {
      background-color: rgb(240, 240, 240);
    }

    &:enabled {
      &:hover, &:focus {
        //background-color: rgb(230, 230, 230);
      }
    }

    &--hasActive {
  		border-radius: 50px;
      // background-image: url(${activeCircle});
      background-repeat: no-repeat;
      background-position: center;
      color: #263039;


      &:enabled {
        &:hover, &:focus {
          background: blue;
        }
      }
    }
     &--active {
      background-image: url(${activeCircle});
      background-repeat: no-repeat;
      background-position: center;
      color: #263039;
      
      abbr {
      			//background-color: white;
      			border-radius: 50px;
      			padding: 6px;
      			min-width: 28px;
      			//padding-right: 5px;
            color: #263039;

      	}
      }

      &:enabled {
        &:hover, &:focus {
          background: lighten(rgb(0, 110, 220), 10%);
        }
      }
    }
    &--selectRange {
    .react-calendar__tile {
      &--hover {
        background-color: rgb(230, 230, 230);
      }
    }
  }
  }
`;

class HealthAdminHistoryMobile extends Component {
  state = {
    student: null,
    date: new Date(),
    healthData: null,
    healthDataRef: null,
  };

  componentDidMount() {
    const { selected } = this.props;
    if (selected) {
      let today = new Date();
      today.setHours(0, 0, 0, 0);
      this.fetchHealthHistory(Math.floor(today.getTime() / 1000));
    }
  }

  onChange = (date) => {
    this.setState({ date });
    let startDate = date.getTime() / 1000;
    this.fetchHealthHistory(startDate);
  };

  fetchHealthHistory = async (date) => {
    const { selected, selectedIsStudent } = this.props;

    this.setState({ loading: true, healthData: null });

    let startDate = date;
    let endDate = date + 86400;

    if (selected) {
      if (selectedIsStudent) {
        await this.props.firebase
          .student(selected.id)
          .collection("health_history")
          .where("post_time", ">=", startDate)
          .where("post_time", "<", endDate)
          .limit(1)
          .get()
          .then((snapshot) => {
            if (snapshot.docs.length > 0) {
              this.setState({
                healthDataRef: snapshot.docs[0].ref,
                healthData: snapshot.docs[0].data(),
              });
            }
          });
      } else {
        await this.props.firebase
          .faculty(selected.id)
          .collection("health_history")
          .where("post_time", ">=", startDate)
          .where("post_time", "<", endDate)
          .limit(1)
          .get()
          .then((snapshot) => {
            if (snapshot.docs.length > 0) {
              this.setState({
                healthDataRef: snapshot.docs[0].ref,
                healthData: snapshot.docs[0].data(),
              });
            }
          });
      }
    }
    this.setState({ loading: false });
  };

  render() {
    const { selected, visible, toggle, selectedIsStudent } = this.props;
    const { loading, date, healthData, healthDataRef } = this.state;

    let dateEpoch = new Date(date);
    dateEpoch.setHours(0, 0, 0, 0);
    dateEpoch = dateEpoch.getTime() / 1000;
    let todayEpoch = new Date();
    todayEpoch.setHours(0, 0, 0, 0);
    todayEpoch = todayEpoch.getTime() / 1000;
    let isFutureDate = dateEpoch > todayEpoch;

    return (
      <Overlay.Container>
        {(overlay) => (
          <Block>
            <FilterOverlay use={Portal} {...overlay} visible={visible}>
              {visible && (
                <Box>
                  <Box bg={"#263039"}>
                    <Box p={2}>
                      <IosArrowBack
                        fontSize={"30px"}
                        color={"white"}
                        onClick={toggle}
                      />
                      {selectedIsStudent ? (
                        <Link to={"/app/profile/" + selected.id}>
                          <Heading color={"white"} as={"h5"} m={0} pl={2}>
                            View {selected.first_name} {selected.last_name}'s
                            Profile{" "}
                            <IosArrowForward
                              style={{ marginBottom: "-0.2em" }}
                              fontSize={"30px"}
                              color={"white"}
                            />
                          </Heading>
                        </Link>
                      ) : (
                        <Heading color={"white"} as={"h5"} m={0} pl={2}>
                          {selected.first_name} {selected.last_name}
                        </Heading>
                      )}
                    </Box>
                    <CalenderWrapper bg={"#263039"} color={"white"} width={1}>
                      <Calendar
                        onChange={this.onChange}
                        value={date}
                        tileClassName={this.handleTileClassNames}
                        showNeighboringMonth={false}
                        prevLabel={
                          <MdArrowDropleft color={"white"} fontSize={"20px"} />
                        }
                        nextLabel={
                          <MdArrowDropright color={"white"} fontSize={"20px"} />
                        }
                      />
                    </CalenderWrapper>
                  </Box>
                  {!isFutureDate ? (
                    loading ? (
                      <Flex width={1} py={3}>
                        <Text color="meta" marginTop="7px" {...textProps}>
                          Loading...
                        </Text>
                      </Flex>
                    ) : (
                      <React.Fragment>
                        <HealthAdminDetails
                          selected={selected}
                          selectedHealthData={healthData}
                          historyView={true}
                          selectedHealthDataRef={healthDataRef}
                          firebase={this.props.firebase}
                          selectedIsStudent={selectedIsStudent}
                          date={date}
                        />
                      </React.Fragment>
                    )
                  ) : (
                    <Text marginTop="7px" {...textProps}>
                      No submissions yet.
                    </Text>
                  )}
                </Box>
              )}
            </FilterOverlay>
          </Block>
        )}
      </Overlay.Container>
    );
  }
}

export default withRouter(HealthAdminHistoryMobile);
